import { render, staticRenderFns } from "./ScoreAgencyChanges.vue?vue&type=template&id=980a75a6&"
import script from "./ScoreAgencyChanges.vue?vue&type=script&lang=js&"
export * from "./ScoreAgencyChanges.vue?vue&type=script&lang=js&"
import style0 from "./ScoreAgencyChanges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports